import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Options} from 'select2';
import { DropdownDataTable } from 'src/app/crm/shared/dropdown-data.table';
import { SelectFieldsTable } from 'src/app/jobboard/modules/jobs/create-job/select-fields.table';
import {HomePageService} from './_services/home-page.service';
import {Select2OptionData} from 'ng-select2';
import { SelectLocationTable } from 'src/app/shared/location-select.table';
import { JobsDataService } from 'src/app/jobboard/modules/jobs/jobs-data.service';
import { JobNumber } from 'src/app/jobboard/jobboard.model';

@Component({
    selector: 'app-home-one',
    templateUrl: './home-one.component.html',
    styleUrls: ['./home-one.component.scss'],
    providers: [DropdownDataTable, SelectFieldsTable, SelectLocationTable]
})
export class HomeOneComponent implements OnInit {
    @Output() sendJob = new EventEmitter<any>();

    constructor(private homeDataService: HomePageService,
        private jobsDataService: JobsDataService,
        private dropDown: DropdownDataTable,
        private selectFields: SelectFieldsTable,
        private locationSelect: SelectLocationTable) {
    }

    public singleOption: Options;
    public multiOptions: Options;

    jobTitle: string;
    city: string;
    // city: Array<any> = [];

    homeLastJobs : any;
    agriJobs= 0;
    hortiJobs = 0;
    zooJobs = 0;
    medicVetJobs = 0;
    alimentsJobs = 0;

    availableJObs = 0;
    availableCompanies = 0;
    yearsOfActivity:any;

    randomPost = [];

     // Domenii, Subdomenii & Categorii
     selectedDomain = null;
     Domains: any = this.dropDown.domains;
 
     subdomains: any;
     subDomainsArray: any = [];
 
     categories: any = [];
     categoriesArray: any = [];
 
     selectSubdomains: string;
     selected: any;

     finalCategories: any = [];
 
     selectedCategories: any;
 

     departments: Array<string> = [];
     selectedDepartments: any = [];
     category: Array<Select2OptionData>;

     isDomainChanged=false;

     loc:any;
    ngOnInit() {
        this.initDropDowns();
        // this.getAgriJobs();
        // this.getHortiJobs();
        // this.getZooJobss();
        // this.getMedicVetJobs();
        // this.getAlimentsJobs();
        // this.getAvailableJobs();
        
        this.getJobsNumber()

        this.getRecentJobs();


        this.loc = this.locationSelect.romaniaCounties;
        console.log('LOC', this.loc);


        this.homeDataService.randomPost().subscribe((post: any) => {
            this.randomPost = post;
            console.log(this.randomPost);
        })

        this.getAllCompanies();
        this.activeYears();

           // Select 2 Options
           this.singleOption = {
            width: '100%',
            allowClear: true
        };
        this.multiOptions = {
            width: '100%',
            allowClear: true
        };

    }

    getJobsNumber() {
        return this.homeDataService.numberAvailableJobsFromActivitySectors().subscribe((jobs: Array<JobNumber>) => {
            jobs.forEach((job:JobNumber) => {

                this.availableJObs = this.availableJObs + job.number;

                if (job.sector == 'Agricultura'){
                    this.agriJobs = job.number;
                }
                if (job.sector == 'Horticultura'){
                    this.hortiJobs = job.number;
                }
                if (job.sector == 'Zootehnie'){
                    this.zooJobs = job.number;
                }
                if (job.sector == 'Medicina veterinara'){
                    this.medicVetJobs = job.number;
                }
                if (job.sector == 'Industria alimentara'){
                    this.alimentsJobs = job.number;
                }
            })
        }, error => {

        })
    }
    // getAgriJobs() {
    //     return this.homeDataService.numberAvailableJobsFromActivitySector('Agricultura').subscribe((data: any) => {
    //         this.agriJobs = data.number;
    //     }, error => {

    //     })
    // }

    // getHortiJobs() {
    //     return this.homeDataService.numberAvailableJobsFromActivitySector('Horticultura').subscribe((data: any) => {
    //         this.hortiJobs = data.number;
    //     }, error => {

    //     })
    // }

    // getZooJobss() {
    //     return this.homeDataService.numberAvailableJobsFromActivitySector('Zootehnie').subscribe((data: any) => {
    //         this.zooJobs = data.number;
    //     }, error => {

    //     })
    // }

    // getMedicVetJobs() {
    //     return this.homeDataService.numberAvailableJobsFromActivitySector('Medicina veterinara').subscribe((data: any) => {
    //         this.medicVetJobs = data.number;
    //     }, error => {

    //     })
    // }

    // getAlimentsJobs() {
    //     return this.homeDataService.numberAvailableJobsFromActivitySector('Industria alimentara').subscribe((data: any) => {
    //         this.alimentsJobs = data.number;
    //     }, error => {

    //     })
    // }

    // getAvailableJobs() {
    //     this.homeDataService.listPublishedJobs(8, 1, {}).subscribe((resp: any) => {
    //         this.availableJObs = resp.totalElements;
    //     })
    // }
    
    getRecentJobs(){
        this.jobsDataService.showRecentJobs().subscribe((data: any) => {
            console.log('recent jobs', data);
            this.homeLastJobs = data.filter((job: any) => 
                job.jobTitle === "FARM MANAGER-FERMA AGRO-ZOOTEHNICA" || 
                job.jobTitle === "ASM HORTICULTURA- Romania SE "
            );        
        })
    }

    getAllCompanies() {
        this.homeDataService.listCompanies(8, 1, {}).subscribe((resp: any) => {
            this.availableCompanies = resp.totalElements;
        })
    }

    activeYears() {
        this.yearsOfActivity = new Date().getFullYear() - 2010;
    }


    scroll(el: HTMLElement) {
        el.scrollIntoView();
    }

    changeDomain(domain: any) {
        this.subDomainsArray = [];
        this.selectSubdomains = undefined;
        this.isDomainChanged=true;
        this.subdomains = this.Domains.find((dmn: any) => dmn.name === domain.target.value).subdomains;
        this.subdomains.forEach(subdomain => {
            this.subDomainsArray.push(subdomain.name); 
        })
    }

    // changeSubDomain(subdomain: any) {
    //     this.selected = subdomain;
    //     this.selectSubdomains = undefined;
    //     if (this.selected) {
            
    //     }
    // }

    initDropDowns(){
        this.departments = this.selectFields.departments;
        this.category = this.selectFields.selectCategory;
    }


    findJob(){
       const job={
           jobTitle : this.jobTitle !== null ? this.jobTitle : undefined,
           city: this.city !== null ? this.city : undefined,
           activitySector: this.selectedDomain !== null ? this.selectedDomain : undefined,
           activitySubSector: this.selectSubdomains !== null ? this.selectSubdomains : undefined,
           department: this.selectedDepartments !== null ? (this.selectedDepartments.length > 0 ? this.selectedDepartments : undefined) : undefined
        }

        this.sendJob.emit(job);
    }
  
    

}
